import { useEffect } from 'react';
import { AppState } from 'state/store';
import { useSelector, useDispatch } from 'react-redux';
import { navigate } from '@reach/router';
import { getProfile } from 'state/user/UserActions';
import { selectIsAuthenticated, selectProfileError, selectAdminStatus } from 'state/user/UserSelectors';
import { AdminStatus } from 'state/user/UserTypes';

export default (adminRoleRequired: boolean = false): boolean => {
   const authenticated: boolean = useSelector((state: AppState) => selectIsAuthenticated(state));
   const profileError: boolean = useSelector((state: AppState) => selectProfileError(state));
   const adminStatus: AdminStatus | undefined = useSelector((state: AppState) => selectAdminStatus(state));
   const dispatch = useDispatch();

   useEffect(() => {
      if (!authenticated) {
         navigate('/');
      } else if (adminRoleRequired && adminStatus === AdminStatus.none) {
         navigate('/unauthorized');
      } else if (!profileError) {
         try {
            dispatch(getProfile());
         } catch (error) {
            console.log(error);
            navigate('/', { state: { message: 'An unknown error occurred. Please try logging in again' } });
         }
      }
   }, [authenticated, adminStatus]);

   useEffect(() => {
      if (profileError) {
         navigate('/', { state: { message: 'An error occurred while gathering your profile data. Please log in to continue' } });
      }
   }, [profileError]);
   return authenticated;
};
